import { Injectable } from "@angular/core"
import { BinanceWebsocketClient } from "../../../market"
import { Observable } from "rxjs"
import { isWsFormattedFuturesUserDataTradeUpdateEvent, WsUserDataEvents } from "libs/binance-api/src"
import { Deal, OrderSide } from "../../../model/trade"

@Injectable({
  providedIn: 'root'
})
export class BinanceDealHandler {

  listen(ws: BinanceWebsocketClient) {
    return new Observable<{deal: Deal}>(subscriber => {
      const f = (data: WsUserDataEvents) => {
        if (isWsFormattedFuturesUserDataTradeUpdateEvent(data) && (data.order.orderStatus == 'PARTIALLY_FILLED' || data.order.orderStatus == 'FILLED')) {
          const deal: Deal = {
            timestamp: data.transactionTime,
            market: 'binance',
            board: 'usdm',
            symbol: data.order.symbol,
            price: data.order.lastFilledPrice,
            quantity: data.order.lastFilledQuantity,
            volume: data.order.lastFilledPrice * data.order.lastFilledQuantity,
            fee: data.order.commissionAmount,
            feeAsset: data.order.commissionAsset,
            side: data.order.orderSide == 'BUY' ? OrderSide.buy : OrderSide.sell,
            dealId: data.order.tradeId,
            orderId: data.order.orderId,
            clientOrderId: data.order.clientOrderId,
          }
          subscriber.next({deal})
        }
      }

      ws.on('formattedUserDataMessage', f)
      return () => ws.off('formattedUserDataMessage', f)
    })
  }

}
